<template>
  <div class="header-logo-wrapper col-auto p-0">
    <div class="logo-wrapper">
      <router-link to="/">
        <img class="img-fluid" src="../../assets/images/logo/logo.png" alt="ClockSpotter" />
        <span class="brand-context">Employer Console</span>
      </router-link>
    </div>
    <div class="toggle-sidebar" @click="toggle_sidebar">
      <vue-feather
        class="status_toggle middle sidebar-toggle"
        type="align-center"
        id="sidebar-toggle"
      ></vue-feather>
    </div>
  </div>

</template>

<script>
  export default {
    name: 'Logo',
    methods: {
      toggle_sidebar() {
        this.$store.dispatch('menu/opensidebar');
      },
    },
  };
</script>

<style scoped>
.logo-wrapper a {
  display: flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
}

.brand-context {
  padding-left: 12px;
  border-left: 1px solid #dce7ed;
  color: #607984;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  line-height: 1.2;
  text-transform: uppercase;
}

@media (max-width: 1199px) {
  .brand-context { display: none; }
}
</style>
